import { useEffect, useState } from 'react';

// FIXME(Yuri): Fix type and add condition for undefined
// https://github.com/vercel/next.js/discussions/18991
/**
 * @param {string} testId
 * @param {number} duration
 * @param {boolean} getIsInitialized
 * @returns {(string | null | {variant: string | null, isInitialized: boolean})}
 */
export function useGoogleOptimize(testId, duration, getIsInitialized = false) {
  const [variant, setVariant] = useState(null);
  const [isInitialized, setIsInitialized] = useState(false);
  useEffect(() => {
    const interval = setInterval(() => {
      if (window.google_optimize !== undefined) {
        const variant = window.google_optimize.get(testId);
        if (typeof variant !== 'undefined') setVariant(variant);
        setIsInitialized(true);
        clearInterval(interval);
      }
    }, duration);
  }, []);
  return getIsInitialized ? { variant, isInitialized } : variant;
}

/**
 * @param {string} testId
 */
export function checkActiveExperiment(testId) {
  window.dataLayer.push('event', 'optimize.callback', {
    name: testId,
    callback: (value, name) =>
      // eslint-disable-next-line no-console
      console.log(`Experiment with ID: ${name} is on variant: ${value}`),
  });
}
